import * as Blockly from 'blockly/core'

const SPRITE_OPTIONS = [
  ['kiko', 'kiko'],
  ['apel', 'apel'],
  ['rock', 'rock'],
  ['ground', 'ground'],
  ['awan', 'awan'],
  ['bintang', 'bintang'],
]

let registered = false

export function registerMotionBlocks() {
  if (registered) return
  registered = true
  Blockly.common.defineBlocksWithJsonArray([
    {
      type: 'motion_move_right',
      message0: '➡️ gerak %1 ke kanan %2',
      args0: [
        { type: 'field_dropdown', name: 'SPRITE', options: SPRITE_OPTIONS },
        { type: 'field_number', name: 'PIXEL', value: 50, min: 1, max: 500 },
      ],
      previousStatement: null,
      nextStatement: null,
      colour: 210,
      tooltip: 'Gerak sprite ke kanan sejauh N pixel',
    },
    {
      type: 'motion_move_left',
      message0: '⬅️ gerak %1 ke kiri %2',
      args0: [
        { type: 'field_dropdown', name: 'SPRITE', options: SPRITE_OPTIONS },
        { type: 'field_number', name: 'PIXEL', value: 50, min: 1, max: 500 },
      ],
      previousStatement: null,
      nextStatement: null,
      colour: 210,
      tooltip: 'Gerak sprite ke kiri sejauh N pixel',
    },
    {
      type: 'motion_move_up',
      message0: '⬆️ gerak %1 ke atas %2',
      args0: [
        { type: 'field_dropdown', name: 'SPRITE', options: SPRITE_OPTIONS },
        { type: 'field_number', name: 'PIXEL', value: 50, min: 1, max: 500 },
      ],
      previousStatement: null,
      nextStatement: null,
      colour: 210,
      tooltip: 'Gerak sprite ke atas sejauh N pixel',
    },
    {
      type: 'motion_move_down',
      message0: '⬇️ gerak %1 ke bawah %2',
      args0: [
        { type: 'field_dropdown', name: 'SPRITE', options: SPRITE_OPTIONS },
        { type: 'field_number', name: 'PIXEL', value: 50, min: 1, max: 500 },
      ],
      previousStatement: null,
      nextStatement: null,
      colour: 210,
      tooltip: 'Gerak sprite ke bawah sejauh N pixel',
    },
    {
      type: 'motion_jump',
      message0: '🦘 loncat %1',
      args0: [{ type: 'field_dropdown', name: 'SPRITE', options: SPRITE_OPTIONS }],
      previousStatement: null,
      nextStatement: null,
      colour: 210,
      tooltip: 'Buat sprite loncat dengan gravitasi',
    },
    {
      type: 'motion_goto',
      message0: '🎯 ke %1 goto x=%2 y=%3',
      args0: [
        { type: 'field_dropdown', name: 'SPRITE', options: SPRITE_OPTIONS },
        { type: 'input_value', name: 'X', check: 'Number' },
        { type: 'input_value', name: 'Y', check: 'Number' },
      ],
      inputsInline: true,
      previousStatement: null,
      nextStatement: null,
      colour: 210,
      tooltip: 'Teleport sprite ke koordinat x,y',
    },
    {
      type: 'math_random',
      message0: '🎲 acak dari %1 sampai %2',
      args0: [
        { type: 'field_number', name: 'MIN', value: 0, min: -999, max: 999 },
        { type: 'field_number', name: 'MAX', value: 100, min: -999, max: 999 },
      ],
      output: 'Number',
      colour: 230,
      tooltip: 'Angka acak antara nilai minimum dan maksimum',
    },
    {
      type: 'sprite_ref',
      message0: 'sprite %1',
      args0: [{ type: 'field_dropdown', name: 'SPRITE', options: SPRITE_OPTIONS }],
      output: 'Sprite',
      colour: 230,
      tooltip: 'Nama sprite yang sudah ditambahkan ke kanvas',
    },
  ])
}
